import { useFormikContext } from 'formik';
import React, { useCallback } from 'react';

import { AutocompleteSelect } from '@candu-ai/analytics/ui';
import { SelectInputWrapper } from 'dashboard/pages/Segment/components/DefinitionFormFields/DefinitionFormComponents';
import { DefinitionFormikValues } from 'dashboard/pages/Segment/components/types';

type EventQueryData = { eventName: string; trackingEventType?: string }[];

type EventSelectItem = {
  data: { eventName: string; [key: string]: any };
  value: string;
  label: string;
};

interface EventSelectProps {
  name: string;
  base: string;
  readOnly?: boolean;
}

export const EventSelect = ({ base, name, readOnly }: EventSelectProps) => {
  const { values, setFieldValue } = useFormikContext<DefinitionFormikValues>();

  // TODO: confirm this is still used, doesn't appear in event data
  const trackingEventTypePath = `${base}.EventOccurred.trackingEventType`;

  const apiQuery = useCallback((search: string) => {
    return {
      query: {
        finder: 'byEventName',
        q: `${search.trim()}`,
      },
    };
  }, []);

  const getFormattedResults = useCallback((results: EventQueryData) => {
    return (
      results.map((result) => {
        return {
          data: result,
          value: result.eventName,
          label: result.eventName,
        };
      }) || []
    );
  }, []);

  const onChange = useCallback(
    (item) => {
      setFieldValue(trackingEventTypePath, item.data?.trackingEventType || 'Global', false);
    },
    [trackingEventTypePath],
  );

  return (
    <AutocompleteSelect<EventSelectItem, EventQueryData, DefinitionFormikValues>
      name={name}
      apiQuery={apiQuery}
      readOnly={readOnly}
      placeholder="Choose an event..."
      selectFirstByDefault
      emptyPlaceholder="You don't have any user events yet"
      onChange={onChange}
      getFormattedResults={getFormattedResults}
      allowCustomValues
      InputWrapper={SelectInputWrapper}
      data-cy="segment-definition-selector"
      values={values}
      setFieldValue={setFieldValue}
    />
  );
};
